export function getFileExtension(filepath) {
  if (!filepath || !filepath.length) return;

  return filepath.split('.').pop().toLowerCase();
}
